module.exports = __webpack_public_path__ + "media/hit_MTV.1e070cb3.mp3";